// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"a1aec213","397":"0e21d190","453":"03346f77"}[chunkId] + ".chunk.js";
};